import API from '@/views/Fdc/Apis/'
// import { mapGetters } from 'vuex'
import Dayjs from 'dayjs'
// import _ from 'lodash'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1. paging 처리

/**
 * Analysis > LOT History
 * LOT History 목록 조회
 */
export default {
  name: 'FdcLotHistory',
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  watch: {
    // rowData () {
    //   if (this.rowData.length === 0) {
    //     this.noData = true
    //   } else {
    //     this.noData = false
    //   }
    // }
  },
  beforeMount () {
    this.initColumns()
  },
  methods: {
    /**
     * Grid Column initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fabId', width: 70, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 70, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_TYPE'), field: 'lotType', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), field: 'substId', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.START_DATE'), field: 'startDt', type: 'dateTimeColumn', width: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.END_DATE'), field: 'endDt', type: 'dateTimeColumn', width: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SLOT'), field: 'slot', numeric: true, width: 60, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), field: 'carrId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROD_ID'), field: 'prodId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROCESS'), field: 'procId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), field: 'reticleId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PPID'), field: 'ppId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.DEVICE'), field: 'device', width: 100 }
      ]
    },

    /**
     * EQP LOT History 목록 조회
     */
    async getEqpLotHistoryList (searchFlag = false) {
      this.treeResult = []

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      let count = this.$refs.fdcEqpTree.$children[1].data.length
      for (let i = 0; i < count; i++) {
        this.treeResult.push(this.$refs.fdcEqpTree.$children[1].getObjFromNode(this.$refs.fdcEqpTree.$children[1].data[i], { isChecked: true, level: 5 }))
      }

      let treeSelectedCount = 0
      // result.forEach((item) => {
      //   if (item.length === 0) {
      //     treeSelectedCount++
      //   }
      // })
      this.treeResult.forEach((item) => {
        if (item.length === 0) {
          treeSelectedCount++
        }
      })

      if (treeSelectedCount >= count) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.MODULE')]))
        return false
      }

      if (this.$refs.fromDate.$data.dateSelected === null || this.$refs.toDate.$data.dateSelected === null) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.PERIOD')]))
        return false
      }
      let params = {}
      let fab = []
      let eqpId = []
      let moduleId = []

      // result.forEach(item => {
      //   item.forEach(data => {
      //     fab.push(data.detail.fab)
      //     eqpId.push(data.detail.eqpId)
      //     moduleId.push(data.detail.moduleId)
      //   })
      // })
      this.treeResult.forEach(item => {
        item.forEach(data => {
          fab.push(data.detail.fab)
          eqpId.push(data.detail.eqpId)
          moduleId.push(data.detail.moduleId)
        })
      })

      if (searchFlag) {
        this.paging.total = 0
        this.paging.totalPage = 0
        this.paging.currentPage = 0
      }

      params = {
        fab: fab + '',
        eqpId: eqpId + '',
        moduleId: moduleId + '',
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999',
        page: this.paging.currentPage,
        size: this.paging.size,
        lotSubstrateValue: this.lotSubstrateValue
      }

      let data = await API.Monitor.getEqpsLots(params)

      this.setLotSubstrateGrid()

      if (data.content.length > 0) {
        this.historyRowData = data.content
        this.originRowData = data.content
        this.paging.total = data.totalElements
        this.paging.totalPage = data.totalPages
        this.paging.currentPage = data.pageable.pageNumber
      } else {
        this.historyRowData = []
        this.originRowData = []
        this.paging.total = 0
        this.paging.totalPage = 0
        this.paging.currentPage = 0
      }
      // if (data._embedded) {
      //   this.rowData = data._embedded.retEventDataVoes
      //   this.originRowData = data._embedded.retEventDataVoes
      //   this.paging.total = data.page.totalElements
      //   this.paging.totalPage = data.page.totalPages
      //   this.paging.currentPage = data.page.number
      // } else {
      //   this.rowData = []
      //   this.originRowData = []
      //   this.paging.total = 0
      //   this.paging.totalPage = 0
      //   this.paging.currentPage = 0
      // }
      // this.tempRowData = [...data]
      // this.paging.total = data.length
      // this.paging.totalPage = Math.floor(data.length / this.paging.size)
      // this.paging.currentPage = 0

      // this.historyRowData = this.tempRowData.slice(this.paging.currentPage * this.paging.size, this.paging.currentPage * this.paging.size + this.paging.size)

      // 검색 된 data에 대한 setting
      this.searchedLotSubstrateValue = this.lotSubstrateValue
    },
    /**
     * columns 배열 설정
     * condition에 Lot 또는 Substrate 선택에 따라 columns 배열을 설정합니다.
     */
    setLotSubstrateGrid () {
      if (this.lotSubstrateValue === 'LOT') {
        this.columns.map(col => {
          if (col.field === 'substId' || col.field === 'slot') {
            col.hide = true
          }
        })
      } else {
        this.columns.map(col => {
          if (col.field === 'substId' || col.field === 'slot') {
            col.hide = false
          }
        })
      }
      this.$refs.eqpLotHistoryGrid.gridApi.setColumnDefs(this.columns)
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    // pagination type 시 page 변경 전 수정여부 확인
    changingPage (event) {

    },
    /**
     * Grid Change Page method
     * @param {*} page current page
     * @param {*} size page size
     */
    changedPage (page, size) {
      this.paging.currentPage = page
      // this.historyRowData = this.tempRowData.slice(this.paging.currentPage * this.paging.size, this.paging.currentPage * this.paging.size + this.paging.size)
      this.getEqpLotHistoryList()
    },
    /**
     * Export Excel
     * 조회된 data를 Excel 파일로 다운로드 합니다.
     */
    exportCSV () {
      this.$refs.eqpLotHistoryGrid.gridApi.exportDataAsCsv({
        fileName: 'EqpLot_History.csv'
      })
      // this.$refs.eqpLotHistoryGrid.exportExcel('EqpLot_History')
      // var objArray = this.$refs.eqpLotHistoryGrid.itemsSource
      // var objArray = new Array()
      // this.$refs.eqpLotHistoryGrid.itemsSource.forEach(item => {
      //   let obj = {
      //     'EQP': item.eqpId,
      //     'Lot Id': item.lotId,
      //     'Lot Type': item.lotType,
      //     'Substrate Id': item.substId,
      //     'Start Date': item.startDt,
      //     'End Date': item.endDt,
      //     'Slot': item.slot,
      //     'Carrier': item.carrId,
      //     'Recipe': item.recipeId,
      //     'Prod': item.prodId,
      //     'Proc': item.procId,
      //     'Reticle': item.reticleId,
      //     'PPID': item.ppId,
      //     'Device': item.device
      //   }
      //   objArray.push(obj)
      // })

      // var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray

      // var csvContent = 'data:text/csv;charset=utf-8,'
      // var header = ''

      // for (var index in array[0]) {
      //   if (index === '_status') continue
      //   header += index + ','
      // }
      // header = header.slice(0, -1)
      // csvContent += header + '\r\n'
      // var value = ''
      // var body = ''
      // for (var i = 0; i < array.length; i++) {
      //   body = ''
      //   for (var bodyIndex in array[i]) {
      //     if (bodyIndex === '_status') continue
      //     value = array[i][bodyIndex]
      //     switch (typeof array[i][bodyIndex]) {
      //       case 'string':
      //         body += '"' + value.replace(/"/g, '""') + '",'
      //         break
      //       case 'boolean':
      //         body += (value === true ? '"' + 'Y' + '"' : '"' + 'N' + '"') + ','
      //         break
      //       default:
      //         body += value + ','
      //         break
      //     }
      //   }
      //   body = body.slice(0, -1)
      //   csvContent += body
      //   if (i < array.length - 1) {
      //     csvContent += '\r\n'
      //   }
      // }
      // const data = encodeURI(csvContent)
      // const link = document.createElement('a')
      // link.setAttribute('href', data)
      // link.setAttribute('download', 'LOT-History_' + Dayjs(new Date()).format('YYYYMMDDHHmmss') + '.csv')
      // link.click()
    },
    /**
     * Parameter Analysis 화면 연동
     */
    redirectParameterAnalysis () {
      let checkedRows = this.$refs.eqpLotHistoryGrid.getCheckedRows()
      if (checkedRows.length) {
      // if (this.$refs.eqpLotHistoryGrid.checkedRows.length > 0) {
        let tempArr = []
        // let tempGridArr = [...this.$refs.eqpLotHistoryGrid.checkedRows]
        let tempGridArr = [...checkedRows]
        this.treeResult.forEach(treeArr => {
          treeArr.forEach(tree => {
            tempArr.push(tree)
          })
        })

        tempArr = tempArr.filter(data => {
          for (let i = 0; i < tempGridArr.length; i++) {
            if (data.detail.fab === tempGridArr[i].fabId &&
                data.detail.eqpId === tempGridArr[i].eqpId &&
                data.detail.moduleId === tempGridArr[i].moduleId) {
              return data
            }
          }
        })

        let treeList = []

        this.treeResult.forEach(item => {
          item.forEach(data => {
            let obj = {
              fab: data.detail.fab,
              eqpId: data.detail.eqpId,
              moduleId: data.detail.moduleId
            }
            treeList.push(JSON.stringify(obj))
          })
        })

        let lotList = []

        tempGridArr.forEach(item => {
          let obj = {
            fab: item.fabId,
            eqpId: item.eqpId,
            moduleId: item.moduleId,
            lotId: item.lotId,
            endDt: item.endDt
          }
          lotList.push(JSON.stringify(obj))
        })

        this.$commonUtil.setSelectedLotHistory(
          {
            treeList: [...treeList],
            lotList: [...lotList]
          }
        )

        let routeData = this.$router.resolve(
          {
            name: 'parameter-analysis',
            query: {
              pageType: 'selectedLotHistory'
              // treeList : [...treeList],
              // lotList: [...lotList]

              // fabList: fab,
              // eqpIdList: eqpId,
              // moduleIdList: moduleId
              // trees: tempArr + '',
              // lots: this.$refs.eqpLotHistoryGrid.checkedRows + ''
            }
          }
        )
        window.open(routeData.href, '_blank')

        // this.$router.push(
        //   {
        //     name: 'parameter-analysis',
        //     params: {
        //       'trees': tempArr,
        //       'lots' : this.$refs.eqpLotHistoryGrid.checkedRows
        //     }
        //   }
        // )
      } else {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Lot']))
      }
    },
    /**
     * LOT History grid에 check된 row가 있는지 체크
     * @returns {*} check된 row가 있는지 여부
     */
    hasCheckedRows () {
      if (!this.$refs.eqpLotHistoryGrid) {
        return 0
      }
      return this.$refs.eqpLotHistoryGrid.checkedRowCount > 0
    }
  },
  data () {
    return {
      treeResult: [], // check된 tree node 배열
      lotSubstrateValue: 'LOT', // Search condition option (LOT / SUBSTRATE)
      searchedLotSubstrateValue: null, // 검색된 Search condition option
      fromDate: Dayjs().subtract(1, 'days').toDate(), // From Date (condition)
      fromMinDate: null, // From Date Min value
      fromMaxDate: new Date(), // From Date Max value
      toDate: new Date(), // To Date (condition)
      toMinDate: Dayjs().subtract(2, 'days').toDate(), // To Date Min value
      toMaxDate: new Date(), // To Date Max value
      // lotHistoryCheckedRows: [],
      columns: [], // LOT History grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      // columns1: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fabId', width: 70, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 70, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_ID'), binding: 'lotId', width: 160, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_TYPE'), binding: 'lotType', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), binding: 'substId', width: 150, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.START_DATE'), binding: 'startDt', dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss', width: 130, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.END_DATE'), binding: 'endDt', dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss', width: 130, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SLOT'), binding: 'slot', numeric: true, width: 60, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), binding: 'carrId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROD_ID'), binding: 'prodId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROCESS'), binding: 'procId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), binding: 'reticleId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PPID'), binding: 'ppId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.DEVICE'), binding: 'device', width: 100, readOnly: true }
      // ], // LOT History grid column 배열 (Substrate 선택)
      // columns2: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fabId', width: 70, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 70, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_ID'), binding: 'lotId', width: 160, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_TYPE'), binding: 'lotType', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.START_DATE'), binding: 'startDt', dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss', centered: true, width: 130, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.END_DATE'), binding: 'endDt', dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss', centered: true, width: 130, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SLOT'), binding: 'slot', numeric: true, width: 60, readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), binding: 'carrId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROD_ID'), binding: 'prodId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROCESS'), binding: 'procId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), binding: 'reticleId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PPID'), binding: 'ppId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.DEVICE'), binding: 'device', width: 100, readOnly: true }
      // ], // LOT History grid column 배열 (LOT 선택)
      tempRowData: [], // LOT History grid row data
      historyRowData: [], // LOT History grid row data
      originRowData: [],
      selectedTreeNode: [], // 선택된 tree node
      // searchTreeNode: [],
      collectionViewOptions: {
        groupDescriptions: ['eqpId']
      }, // LOT History grid collectionView Option
      paging: {
        // type: ['none', 'load-more', 'pagination'][2],
        size: 100, // page per size 설정
        currentPage: 0, // 0으로 초기설정
        totalPage: 1, // 1로 초기설정
        totalElements: 1
      }, // LOT History grid pagination option
      noData: false // data 없음 여부
    }
  }
}
